<!--
  Authored.by.KWShin.2025.11.04.
-->
<template>
  <div class="wrap-alert-conten-monitor">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <span style="margin-top: 6px; margin-left: 10px">{{ $t('alert.monitor.label.system') }} :</span>
        <system-linked-combo v-model="select" hide-stack></system-linked-combo>
        <span style="margin-top: 6px; margin-left: 10px">{{ $t('alert.monitor.label.pgm.nm') }} :</span>
        <v-toolbar dense flat height="32px">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-autocomplete name="pgmNm" v-model="srchPm.pgmNm" :items="pgmNmList" @update:search-input="searchPm"
            :label="$t('alert.monitor.ph.pgm.nm')" clearable dense flat hide-no-data hide-details solo style="width: 260px">
          </v-autocomplete>
        </v-toolbar>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="ml-2 mt-1" x-small color="primary" @click="fetchData()">
              <v-icon small>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('common.retrieve') }}</span>
        </v-tooltip>
        <div class="mr-1 wrap-append-align-right">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="mr-1" @click="uploadFormOpen()" x-small color="primary">
                <v-icon small>mdi-progress-upload</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('common.upload') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="formOpen('new', null)" x-small color="primary">
                <v-icon small>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('common.add') }}</span>
          </v-tooltip>
        </div>
      </div>
    </v-card>
    <v-row>
      <v-col cols="12">
        <!--eslint-disable-next-line prettier/prettier-->
        <v-data-table
          :headers="headers" :items="pmList" item-key="programName"
          :items-per-page="paging.rowsPerPage" :loading="loading" height="400px"
          class="elevation-1 content table-pd-s"
          dense fixed-header disable-pagination hide-default-footer single-select
          @click:row="highlight"
        >
          <template v-slot:top>
            <MonitorForm :isShow="showForm" :formMode="formMode" :pmKey="pmKey" @formClose="formClose" />
          </template>
          <template #item.pgmNm="{ item }">
            <v-tooltip content-class="tooltip" top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="col-ellipsis" :style="{ 'max-width': '245px' }">{{ item.pgmNm }}</div>
              </template>
              <span small>{{ item.programText }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.active="{ item }">
            <v-simple-checkbox v-model="item.active" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.beginEnd="{ item }">
            <v-simple-checkbox v-model="item.beginEnd" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.elapse="{ item }">
            <v-simple-checkbox v-model="item.elapse" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.notEnd="{ item }">
            <v-simple-checkbox v-model="item.notEnd" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.cancel="{ item }">
            <v-simple-checkbox v-if="item.programType == 'BATCH_JOB'" v-model="item.cancel" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template #item.programDescription="{ value }">
            <div class="col-ellipsis" :style="{ 'max-width': '245px' }">{{ value }}</div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mr-2" color="primary" @click="formOpen('upd', item)">mdi-pencil-box-multiple-outline</v-icon>
              </template>
              <span>{{ $t('common.edit') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="primary" @click="deleteItem(item)">mdi-trash-can-outline</v-icon>
              </template>
              <span>{{ $t('common.delete') }}</span>
            </v-tooltip>
          </template>
          <template #footer><pagination :paging.sync="paging" :length="length" :disabled="loading"></pagination></template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="uploadDialog" max-width="400px" persistent>
      <v-card :class="classContents">
        <v-card-title>
          <h3>File {{ this.$t('common.upload') }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon x-small @click="closeUpload()">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="meta-form-pd">
          <v-form ref="monitorForm">
            <v-file-input label="File input" v-model="uploadFile" :placeholder="this.$t('common.noFileSelect')" class="w-auto" outlined dense></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="upload()" :disabled="btnUploadDisable">{{ this.$t('common.upload') }}</v-btn>
          <v-btn small color="primary" @click="closeUpload()">{{ this.$t('common.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import MonitorForm from './MonitorForm';

export default {
  name: 'Monitor',
  components: {
    MonitorForm,
  },
  data() {
    return {
      /* condition */
      select: { stack: 'ABAP', system: '' },
      srchPm: {},
      pgmNmList: [],
      /* data table */
      loading: false,
      length: 0,
      paging: { page: 1, rowsPerPage: 100 },
      pmList: [],
      /* data */
      formData: {},
      formMode: '',
      pmKey: {},
      uploadDialog: false,
      uploadFile: [],
      /* form */
      showForm: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('alert.monitor.type'), value: 'programTypeName', width: '80px', sortable: false },
        { text: this.$t('alert.monitor.program.name'), value: 'pgmNm', width: '200px', sortable: false },
        { text: this.$t('alert.active'), value: 'active', width: '68px', sortable: false, align: 'center' },
        { text: this.$t('alert.monitor.beginEnd'), value: 'beginEnd', width: '68px', sortable: false, align: 'center' },
        { text: this.$t('alert.monitor.elapse'), value: 'elapse', width: '68px', sortable: false, align: 'center' },
        { text: this.$t('alert.monitor.notEnd'), value: 'notEnd', width: '68px', sortable: false, align: 'center' },
        { text: this.$t('alert.monitor.cancel'), value: 'cancel', width: '68px', sortable: false, align: 'center' },
        { text: this.$t('alert.description'), value: 'programDescription', sortable: false },
        { text: '', value: 'actions', width: '64px', sortable: false, align: 'center' },
      ];
    },
    btnUploadDisable() {
      return this.uploadFile.name === undefined ? true : false;
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  watch: {
    'select.system'() {
      this.fetchData();
    },
  },
  methods: {
    highlight(item, { isSelected, select }) {
      select(!isSelected);
    },
    async searchPm(input) {
      // v-autocomplete 컴포넌트가 created() 되면 초기값이 null이어서 pgmNmList가 빈 array이어서 무한루프가 발생한다.
      // 또한, 값이 변하지 않은 상태이면 pgmNmList를 조회하러 갈 필요없다.
      if (input === null || input == this.srchPm.key) return;
      this.pgmNmList = await this.autoSearch('pgmNm', { systemId: this.select.system, pgmNm: input.toUpperCase() });
      // 실제 DB에 없는 프로그램/배치잡 명('%'문자가 포함된 것)을 입력할 수 있도록 현재 입력된 값을 items에 추가해준다.
      this.pgmNmList.unshift(input);
    },
    async autoSearch(uri, params) {
      const { data: items } = await api.get(`/preference/program-monitor/auto-search/${uri}`, {
        params: {
          ...params,
        },
      });
      return items;
    },
    async fetchData() {
      this.loading = true;
      const params = {
        systemId: this.select.system,
        pgmNm: this.srchPm.pgmNm,
        page: this.paging.page,
        limit: this.paging.rowsPerPage,
      };
      const {
        data: { items, pagination },
      } = await api.get('/preference/program-monitors/like-all', { params });
      this.pmList = items;
      this.length = pagination.totalCount;
      this.loading = false;
    },
    formOpen(formMode = 'new', item) {
      this.formMode = formMode;
      if (formMode == 'new') {
        this.pmKey = {
          systemId: this.select.system,
          programName: '',
          programType: 'NORMAL',
        };
      } else {
        this.pmKey = {
          systemId: item.systemId,
          programName: item.programName,
          programType: item.programType,
        };
        if (item.programType == 'BATCH_JOB') this.formMode = 'batch-upd';
      }
      this.showForm = true;
    },
    formClose(param) {
      this.showForm = false;
      if (param == 'save') this.fetchData();
    },
    async deleteItem(item) {
      if (await this.$dialog.confirm(this.$t('common.delete.q'))) {
        const data = {
          systemId: item.systemId,
          programName: item.programName,
        };
        const { status } = await api.delete('/preference/program-monitors', { data });
        if (status === 200) this.sucess();
      }
    },
    uploadFormOpen() {
      this.uploadDialog = true;
    },
    closeUpload() {
      this.uploadDialog = false;
      this.uploadFile = [];
    },
    async upload() {
      const formData = new FormData();
      formData.append('file', this.uploadFile);
      const { status } = await api.post('/preference/program-monitors-all', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (status === 200) {
        this.closeUpload();
        this.sucess();
      }
    },
    sucess() {
      this.$dialog.info(this.$t('common.successful'));
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
.col-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
